import React from 'react';
import { injectIntl, intlShape } from 'react-intl';

import Button from 'common/components/Button';
import PropTypes from '../../propTypes';
import { TranslatedMessage, translateMessage } from 'common/components/Intl';
import * as m from '../../messages';

const DobWarningModalContent = ({ intl, ...props }) => {
  const supportLinkText = translateMessage(
    intl,
    m.DOB_WARNING_MODAL_SUPPORT_INFO_LINK_TEXT
  );
  const supportLinkUrl = translateMessage(intl, m.SUPPORT_URL);
  const SupportLink = <a href={supportLinkUrl}>{supportLinkText}</a>;

  return (
    <div className="container-fluid">
      <div className="ConfirmationModal__title bold new-h3">
        <TranslatedMessage
          id={m.DOB_WARNING_MODAL_TITLE}
          values={{ age: props.age }}
        />
      </div>
      <p className="ConfirmationModal__text new-text navy">
        <TranslatedMessage
          id={m.DOB_WARNING_MODAL_DESCRIPTION}
          values={{ age: props.age }}
        />
      </p>
      <p className="ConfirmationModal__text new-text bold navy">
        <TranslatedMessage id={m.DOB_WARNING_MODAL_DISCLAIMER} />
      </p>
      <p className="ConfirmationModal__text new-text--small">
        <TranslatedMessage
          id={m.DOB_WARNING_MODAL_SUPPORT_INFO}
          values={{
            support_info_link_text: SupportLink,
          }}
        />
      </p>
      <div className="row center-xs">
        <Button
          onClick={props.onClose}
          id="acknowledge"
          className="ConfirmationModal__Button"
        >
          <TranslatedMessage id={m.DOB_WARNING_MODAL_BUTTON_TEXT} />
        </Button>
      </div>
    </div>
  );
};

DobWarningModalContent.propTypes = {
  onClose: PropTypes.func,
  intl: intlShape.isRequired,
};

export default injectIntl(DobWarningModalContent);
